var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmitButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "48px",
    viewBox: "0 0 47 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SubmitButton") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Submit",
    transform: "translate(-139, 0)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178,0 C182.418278,-8.11624501e-16 186,3.581722 186,8 L186,40 C186,44.418278 182.418278,48 178,48 L147,48 C142.581722,48 139,44.418278 139,40 L139,8 C139,3.581722 142.581722,-9.64732338e-16 147,0 L178,0 Z M163.712654,12 L161.446267,14.3095856 L169.323144,22.3335622 L149.550289,22.3335622 L149.550289,25.6664378 L169.323144,25.6664378 L161.446267,33.7111093 L163.712654,36 L175.462654,24 L163.712654,12 Z",
    id: "SubmitButton"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitButton);
export default __webpack_public_path__ + "static/media/SubmitButton.d6b7dc306efe67bcd9e0cc79061fc013.svg";
export { ForwardRef as ReactComponent };